require('./style.less');

var Marionette = require('marionette');
var FullTextSearchBar = require('./searchBar/view');
var NAVHits = require('./navBar/view');

require('jqToggleButton');

module.exports = Marionette.LayoutView.extend({
    template: require('./template'),
    initialize: function() {
        this.listenTo(this.options.lCh, 'updateGrepToggleBtnState', this._updateGrepBtnState );
    },
    regions: {
        center:     '#esFootCenter',
        right:      '#esFootRight'
    },
    ui: {
        toggleHitBtn:       '#esToggleHits',
        toggleGrepBtn:      '#esToggleGrep',
        toggleSimpleBtn:    '#esToggleSimple'
    },
    serializeData: function() {

        var nHits = this.model.getNumberOfHits(),
            noHitsExist = nHits < 1;

        return {
            docOnServerAndNoFetchErr: this.model.docOnServerAndNoFetchErr(),
            showNoResultsFoundIndicator: noHitsExist && !this.model.isBlankSearch(),
            showHitNav: this.options.lCh.request('showHitsInView'),
            showGrepBtn: !noHitsExist //-- disable instead b/c of space?
        };

    },
    onBeforeShow: function() {

        var opts = {
            model: this.model,
            lCh: this.options.lCh
        };

        this._createToggleSimpleBtn();
        this._createToggleGrepBtn(); //always create/show: if switching documents, and grep mode is on, and no hits are found, it looks like no text was returned from the query

        if (this.model.getNumberOfHits() > 0) {
            this._createToggleHitsBtn();
        }

        this.center.show(new FullTextSearchBar(opts));

        /* besides errors here, must check if there are hits -- unlike other places -- otherwise the html will be overwritten when no results */
        this.model.docOnServerAndNoFetchErr() && this.model.getNumberOfHits() > 0 && this.right.show( new NAVHits(opts) ) ;
    },
    _createToggleHitsBtn: function() {
         var lc = this.options.lCh;
         this.ui.toggleHitBtn.toggleButton({
            isActive: lc.request('showHitsInView'),
            toggleAction: function() {
                lc.command('showHits');
            },
            activeTitle: 'Hide',
            inactiveTitle: 'Show'
        });
    },
    _createToggleGrepBtn: function() {
        var lc = this.options.lCh;
        this.ui.toggleGrepBtn.toggleButton({
            isActive: lc.request('isInGrepMode'),
            toggleAction: function() {
                lc.command('toggleGrepMode');
            },
            activeTitle: 'Show all lines',
            inactiveTitle: 'Only show lines with hits'
        });
    },
    _createToggleSimpleBtn: function() {
        var lc = this.options.lCh;
        this.ui.toggleSimpleBtn.toggleButton({
            isActive: lc.request('isInSimpleMode'),
            toggleAction: function() {
                lc.command('toggleSimpleMode');
            },
            activeTitle: 'Exit Simple Mode',
            inactiveTitle: 'Enter Simple Mode'
        });
    },
    /* necessary b/c mode can be toggle not just by clicking the btn: eg clicking a hit */
    _updateGrepBtnState: function(grepMode) {
        this.ui.toggleGrepBtn.trigger(grepMode ? 'toggleOn': 'toggleOff');
    },
    onBeforeDestroy: function() {
        //_.invoke([this.ui.toggleHitBtn, this.ui.toggleGrepBtn], 'destroy');
        this.ui.toggleHitBtn.destroy && this.ui.toggleHitBtn.destroy(); //hmmm sometimes, doesn't have the fn
        this.ui.toggleGrepBtn.length > 0 && this.ui.toggleGrepBtn.destroy(); //(may not exist)
        this.ui.toggleSimpleBtn.length > 0 && this.ui.toggleSimpleBtn.destroy();
        this.$('*').remove();
        this.$el.remove();
    }
   
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/footer/view.js
 ** module id = 530
 ** module chunks = 0
 **/